module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('app-page-header'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.contratos,
      "label": "Curso",
      "no-data-text": "Nenhum curso encontrado",
      "clearable": "",
      "item-value": "id",
      "item-text": "descricao"
    },
    on: {
      "input": _vm.selecionaContrato
    },
    model: {
      value: (_vm.contrato),
      callback: function($$v) {
        _vm.contrato = $$v
      },
      expression: "contrato"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.periodos,
      "label": "Período",
      "no-data-text": "Nenhum períodos encontrado",
      "clearable": "",
      "item-value": "periodo",
      "item-text": "descricao"
    },
    model: {
      value: (_vm.periodo),
      callback: function($$v) {
        _vm.periodo = $$v
      },
      expression: "periodo"
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.habilitarGeracaoAtestado) ? _c('empty-list', {
    attrs: {
      "title": "Selecione o Curso/Período",
      "description": "Para habilitar a geração do atestado você precisa selecionar o curso e período"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center atestados-gerar-botoes"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "large": "",
      "disabled": !_vm.habilitarGeracaoAtestado
    },
    on: {
      "click": function($event) {
        return _vm.gerarAtestado()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-print"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v("Gerar Atestado")])])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%"
    },
    model: {
      value: (_vm.mostratModalAtestado),
      callback: function($$v) {
        _vm.mostratModalAtestado = $$v
      },
      expression: "mostratModalAtestado"
    }
  }, [_c('v-card', {
    staticClass: "modal-pdf"
  }, [_c('v-card-text', [_c('iframe', {
    attrs: {
      "src": _vm.atestadoBase64
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostratModalAtestado = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-245028c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/academico/components/AtestadoTrancamento.vue
// module id = 529
// module chunks = 2